import React, { useState } from 'react'
import { Link } from 'react-router'
import { useDispatch } from 'react-redux'
import classnames from 'classnames'
import SwitchToggle from './SwitchToggle'
import WhitelistToggle from './WhitelistToggle'
import BlacklistToggle from './BlacklistToggle'
import '../../styles/category-switch.pcss'
import {
  blacklistTag,
  unblacklistTag,
  unwhitelistTag,
  whitelistTag,
  blacklistCategory,
  unblacklistCategory,
  unwhitelistCategory,
  whitelistCategory,
} from '../../user/userActions'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import useClickAway from '../../hooks/useClickAway'

const Switch = ({ tag }) => {
  const dispatch = useDispatch()
  const [showMenu, setShowMenu] = useState(false)
  const ref = React.useRef(null)

  useClickAway(ref, () => {
    if (showMenu) {
      setShowMenu(false)
    }
  })

  const id = tag.get('id')
  const slug = tag.get('slug')
  const isCategory = tag.get('type') === 'category'
  const name = isCategory ? tag.get('name') : '#' + tag.get('name')
  const link = isCategory ? `/${slug}` : `/t/${slug}`
  const isWhitelisted = tag.get('whitelisted')
  const isBlacklisted = tag.get('blacklisted')

  const handleToggleClick = (event) => {
    event.stopPropagation()
    setShowMenu(!showMenu)
  }

  const handleWhitelist = () => {
    dispatch(isCategory ? whitelistCategory(id) : whitelistTag(id))
    setShowMenu(false)
  }

  const handleUnwhitelist = () => {
    dispatch(isCategory ? unwhitelistCategory(id) : unwhitelistTag(id))
    setShowMenu(false)
  }

  const handleBlacklist = () => {
    dispatch(isCategory ? blacklistCategory(id) : blacklistTag(id))
    setShowMenu(false)
  }

  const handleUnBlacklist = () => {
    dispatch(isCategory ? unblacklistCategory(id) : unblacklistTag(id))
    setShowMenu(false)
  }

  return (
    <span
      className={ classnames('category-switch', {
        'category-switch_whitelisted': isWhitelisted,
        'category-switch_blacklisted': isBlacklisted,
      }) }
      ref={ ref }
    >
      <Link className='category-switch__label' to={ link }>{ name }</Link>
      <SwitchToggle
        onClick={ handleToggleClick }
        isWhitelisted={ isWhitelisted }
        isBlacklisted={ isBlacklisted }
        name={ name }
      />

      { showMenu ?
        <div className='category-switch__menu-container'>
          <WhitelistToggle
            isWhitelisted={ isWhitelisted }
            onWhitelist={ handleWhitelist }
            onUnwhitelist={ handleUnwhitelist }
            name={ name }
          />
          <BlacklistToggle
            isBlacklisted={ isBlacklisted }
            onBlacklist={ handleBlacklist }
            onUnblacklist={ handleUnBlacklist }
            name={ name }
          />
        </div> : null
      }
    </span>
  )
}

Switch.propTypes = exact({
  tag: ImmutablePropTypes.mapContains({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    blacklisted: PropTypes.bool.isRequired,
    whitelisted: PropTypes.bool.isRequired,
  }),
})

export default Switch
